import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import A5Screening from "@/components/Screening/A5Screening";
import AccountSetupWorkflow from "@/portals/(workflows)/(account-setup)/AccountSetupWorkflow";
import AdvancedCarePolicyPage from "@/portals/(shared)/AdvancedCarePolicyPage";
import Authentication from "@/containers/Authentication/Authentication";
import EmailVerification from "@/components/Common/EmailVerification";
import HCPWorkflow from "@/portals/(workflows)/(hcp-referral)/HCPWorkflow";
import HipaaPolicyPage from "@/portals/(shared)/HipaaPolicyPage";
import Home from "@/containers/Home/Home";
import MobileAddPayment from "@/components/Common/MobileAddPayment/MobileAddPayment";
import { OnboardingWorkflow } from "@/portals/(workflows)/(onboarding)/components/OnboardingWorkflow";
import PricingPage from "@/portals/(shared)/PricingPage";
import privacyPolicy from "@/components/Common/PrivacyPolicy";
import PrivacyPolicyPage from "@/portals/(shared)/PrivacyPolicyPage";
import RedirectSplashScreen from "@/redirectSplashScreen";
import TermsAndConditionsPolicyPage from "@/portals/(shared)/TermsAndConditionsPolicyPage";
import TreatmentPolicyPage from "@/portals/(shared)/TreatmentPolicyPage";
import Unsubscribe from "@/components/Common/Unsubscribe";

export const getUnauthenticatedRoutes = (allowRedirect, props) => (
  <Switch>
    <Route component={Home} exact path="/" />
    <Route component={AccountSetupWorkflow} path="/account-setup" />
    <Route component={Authentication} path="/auth" />
    <Route component={privacyPolicy} path="/privacy-policy" />
    <Route component={PricingPage} path="/session-pricing" />
    <Route component={A5Screening} path="/a5-screening" />
    <Route component={Unsubscribe} path="/unsubscribe" />
    <Route component={EmailVerification} path="/email-verification" />
    <Route component={OnboardingWorkflow} path="/app/workflow" />
    <Route component={MobileAddPayment} path="/app/mobile-add-payment" />

    <Route component={AdvancedCarePolicyPage} path="/advanced-care" />
    <Route component={TreatmentPolicyPage} path="/consent" />
    <Route component={HipaaPolicyPage} path="/hipaaprivacy" />
    <Route component={PrivacyPolicyPage} path="/privacy" />
    <Route component={TermsAndConditionsPolicyPage} path="/terms-and-conditions" />

    <Route
      component={(compProps) => (
        <RedirectSplashScreen {...compProps} redirectPath={props.auth.authRedirectPath} />
      )}
      path="/redirect"
    />

    <Route component={HCPWorkflow} path="/app/hcp-workflow" />

    {allowRedirect && <Redirect to="/auth" />}
  </Switch>
);
